import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import './css/global.css'
import Vue3Toastify, { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import { createPinia } from 'pinia';
import {createI18n} from 'vue-i18n';
import "flag-icons/css/flag-icons.min.css";

import App from './App.vue'
import router from './router';
import en from './locales/en.json'
import serb from './locales/serb.json'
import tr from './locales/tr.json'

const app = createApp(App)
const pinia = createPinia();

const i18n = createI18n({
    legacy: false,
    locale: 'en',
    // locale: 'serb',
    globalInjection: true,
    messages: {
        en,
        serb,
        tr
    }
});

// Enable Vue Devtools
// app.config.devtools = true;

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

app.use(pinia);
app.use(router);
app.use(ElementPlus);
app.use(Vue3Toastify,
    {
        autoClose: 10000,
        position: toast.POSITION.TOP_RIGHT
        // ...
    },
);
app.use(i18n);
app.mount('#app')
